import React from 'react'
import PromoCardsPanel from './PromoCardsPanel'

const AdminPromoCards = () => <PromoCardsPanel />

export default AdminPromoCards
